import { useEffect, useState } from 'react'
import {
  fetchGlobalUiState,
  saveGlobalUiState,
} from '../../../../infrastructure/api/ui-states'

const FAB_DISMISSED_KEY = 'AI_AGENT_CHAT_FAB_DISMISSED'

/**
 * AIチャット起動ボタンを引っ込めたかどうかを、リロードをまたいで保持するフック。
 *
 * 起動ボタンは画面右下に固定で表示され続けるため、一度引っ込めたのに
 * リロードのたびに再表示されると引っ込める操作の意味がなくなる。
 *
 * 取得は非同期なので、復元前に描画すると引っ込めたはずのボタンが一瞬見えてしまう。
 * 呼び出し側が isRestored を見てボタンの描画を待てるようにしている。
 */
export const useFabDismissal = (): {
  isDismissed: boolean
  isRestored: boolean
  changeDismissed: (dismissed: boolean) => void
} => {
  const [isDismissed, setIsDismissed] = useState(false)
  const [isRestored, setIsRestored] = useState(false)

  useEffect(() => {
    const restore = async () => {
      try {
        const stored = await fetchGlobalUiState<boolean>(FAB_DISMISSED_KEY)
        if (typeof stored === 'boolean') {
          setIsDismissed(stored)
        }
      } catch (e) {
        // 表示状態を復元できないだけでチャットは使えるため、通知せず常設状態で表示する。
        console.warn('Failed to restore the AI agent chat fab state.', e)
      } finally {
        setIsRestored(true)
      }
    }
    restore()
  }, [])

  const changeDismissed = (dismissed: boolean) => {
    // 保存完了を待つとボタンの反応が鈍るため、表示は即座に切り替える。
    setIsDismissed(dismissed)
    saveGlobalUiState(FAB_DISMISSED_KEY, dismissed).catch(e => {
      console.warn('Failed to store the AI agent chat fab state.', e)
    })
  }

  return { isDismissed, isRestored, changeDismissed }
}
